import { render, staticRenderFns } from "./PredictionTableForm.vue?vue&type=template&id=b7758f28&scoped=true&"
import script from "./PredictionTableForm.vue?vue&type=script&lang=js&"
export * from "./PredictionTableForm.vue?vue&type=script&lang=js&"
import style0 from "./PredictionTableForm.vue?vue&type=style&index=0&id=b7758f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7758f28",
  null
  
)

export default component.exports